import React, { useEffect } from 'react';
import {
    Container,
    HeroContainer,
    BodyContainer
} from '../StyledComponents/StyledComponents';
import styled from 'styled-components';

const CenteredHeroContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
    padding: 0 2rem;
`;

const HeroTitle = styled.h1`
    opacity: 1;
    animation: fadeInTitle 1s ease-out;
    text-align: center;
    display: block;
    width: 100%;
    line-height: 1.1;
    margin: 0 auto 1.5rem auto;
    white-space: normal;
    transform: none;
    position: relative;
    left: auto;
    right: auto;
    font-family: ${props => props.theme.typography.headerFont};
    font-weight: 700;
    color: ${props => props.theme.body.headers};
    font-size: 3rem;
    
    @keyframes fadeInTitle {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @media (max-width: ${props => props.theme.queries.mobile}) {
        font-size: 2rem;
    }
`;

const HeroSubtitle = styled.p`
    opacity: 0;
    transform: translateY(20px);
    transition: all 0.6s ease-out;
    text-align: center;
    max-width: 600px;
    margin: 0 auto 2rem auto;
    font-size: 1.2rem;
    color: ${props => props.theme.body.text};
    
    &.show {
        opacity: 1;
        transform: translateY(0);
    }
`;

const PlaygroundHero = () => {
    useEffect(() => {
        setTimeout(() => {
            const subtitle = document.querySelector('.playground-subtitle');
            if (subtitle) {
                subtitle.classList.add('show');
            }
        }, 800);
    }, []);

    return(
        <HeroContainer
            animate={{ opacity: 1 }}
            initial={{ opacity: 0 }}
            transition={{ duration: 2, delay: 1 }}
            exit={{ opacity: 0 }}
        >
            <BodyContainer>
                <CenteredHeroContent>
                    <HeroTitle>
                        Laboratorio de Estilos
                    </HeroTitle>
                    <HeroSubtitle className="playground-subtitle">
                        Experimentando con diferentes diseños de tarjetas y componentes
                    </HeroSubtitle>
                </CenteredHeroContent>
            </BodyContainer>
        </HeroContainer>
    )
}

export default PlaygroundHero;
